import { FunctionComponent } from "react";
import "./SplashScreen.scss";
import images from "../../assets/images";


const SplashScreen: FunctionComponent = () => {
  const { splashImage } = images;
  
  return (
    <div className="logoContainer">
      <img className="logoIcon" alt="splashImage" src={ splashImage } />
    </div>
  );
};

export default SplashScreen;
